import NumberFormat from 'react-number-format';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function ProgressFormatter({ info, value: propsValue }) {
  const { value } = propsValue ? { value: propsValue } : getInfo(info)
  if (!value) {
    return '0%'
  }

  return <NumberFormat value={value} displayType="text" suffix={'%'}
    decimalSeparator="." decimalScale={0} fixedDecimalScale={true} />
}
